var React = require('react');

function ParkingSlash (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M106.27 50.36A47.91 47.91 0 0 1 144 32h352a48 48 0 0 1 48 48v308.68L410 285.09A95.93 95.93 0 0 0 336 128h-96a16.06 16.06 0 0 0-15.79 13.52zM336 192h-46.47l69.74 53.9A32 32 0 0 0 336 192zm-48 176a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-64.86L96 204.21V432a48 48 0 0 0 48 48h308.83L288 352.6z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M3.37 31.45L23 6.18a16 16 0 0 1 22.47-2.81L633.82 458.1a16 16 0 0 1 2.82 22.45L617 505.82a16 16 0 0 1-22.46 2.81L6.18 53.9a16 16 0 0 1-2.81-22.45z","className":"fa-primary","key":2})]);
}

ParkingSlash.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = ParkingSlash;

ParkingSlash.default = ParkingSlash;
